"use client";

import { useEffect, useRef } from "react";
import Image from "next/image";

// Static city images for hero background
const heroImages = [
  "/1920px-Toronto_by_Sentinel-2.jpg",
  "/brampton_aerial_view.jpg",
  "/etobicoke-skyline.jpg",
];

export default function ParallaxHero({ children }) {
  const heroRef = useRef(null);
  const bgRef = useRef(null);

  // Parallax scroll effect
  useEffect(() => {
    const handleScroll = () => {
      if (bgRef.current && heroRef.current) {
        const scrolled = window.scrollY;
        const heroHeight = heroRef.current.offsetHeight;

        if (scrolled < heroHeight * 1.5) {
          const parallaxSpeed = 0.4;
          bgRef.current.style.transform = `translateY(${scrolled * parallaxSpeed}px)`;
        }
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      ref={heroRef}
      className="relative bg-gray-900 text-white py-16 sm:py-24 overflow-hidden"
    >
      {/* City Image Collage Background - parallax with rhombus shape */}
      <div
        ref={bgRef}
        className="absolute inset-0 will-change-transform"
        style={{ top: "-20%", height: "140%" }}
      >
        <div className="absolute inset-0 flex -skew-x-12 scale-125 origin-center">
          {heroImages.map((src, index) => (
            <div key={index} className="w-1/3 h-full relative overflow-hidden">
              <Image
                src={src}
                alt=""
                fill
                className="object-cover skew-x-12 scale-125 opacity-50"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-blue-900/70 via-blue-800/60 to-indigo-900/70"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-gray-900/40 to-transparent"></div>

      {/* Inner shadow at bottom for depth */}
      <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/30 to-transparent"></div>

      {/* Content */}
      {children}
    </header>
  );
}
